import api from './axiosInstance';

export const excelExportLogService = {
  log: async (payload) => {
    try {
      const response = await api.post('/excel-exports/log', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo registrar el log de exportación.';
      throw error;
    }
  },
};
